export const getInventoryStores = () => {
    return ["101", "530"];
};
